import React from "react";
import { Global } from "./component/styled/Global";
import { Form } from "./component/Form";

export const App = () => {
  return (
    <>
      <Global />
      <Form/>
    </>
  );
};
